var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idea-box mt20 mr20"},[_c('div',{staticClass:"left"},[_c('Material')],1),_c('div',{staticClass:"right"},[_c('SelectMaterial')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }